//公共方法
export default {
    methods: {
        routeTo: function(e) { // 单页路由和业务路由
            var v = this,
                p1 = Number(e.split('-')[0]),
                p2 = Number(e.split('-')[1]),
                inGroupId = v.$store.state.inGroupId,
                url = window.location.href;
            v.$store.commit('active', e);

            var _to = this.menuMap.filter(function(val) {
                return val.id === p2;
            })[0];

            if (this.getInGroupIdByMenu(_to) === inGroupId) {
                v.$store.commit('thisPage', this.getLastPageName(_to.link));
                v.$router.push(_to.link.split('#/')[1]);
            } else {
                var domain = url.split('/')[0];
                window.location.href = domain + _to.link;
            }

        },
        getLastPageName: function(url) {
            var l;
            if (url != undefined && url.indexOf('?') > 0) {
                url = url.split('?')[0].split('/')
                l = url.length;

            } else if (url != undefined && url.indexOf('?') < 0) {
                url = url.split('/');
                l = url.length;

            }
            return url[l - 1];
        },
        getInGroupIdByMenu: function(data) {
            var _InGroupId = '';
            var _func = function(targetId) {
                this.menuMap.forEach(function(val) {
                    if (val.id === targetId) {
                        if (val.pid) {
                            _func(val.pid);
                        } else {
                            _InGroupId = val.id
                        }
                    }
                });
            }.bind(this);
            _func(data.pid);
            return _InGroupId;
        },
        // 页面不够撑开自动填白
        whiteAuto: function(main) {
            var paddingH = function() {
                this.$nextTick(function() {
                    var totalHeight = document.body.clientHeight;
                    var taskBoxHeight = document.querySelector('.' + main).offsetHeight;
                    var navHeight = document.querySelector('.ivu-menu-horizontal').offsetHeight;
                    var breadHeight = document.querySelector('.layout-breadcrumb').offsetHeight + 9;
                    var paddingHeight = (totalHeight - taskBoxHeight - navHeight - breadHeight) + 'px'
                    console.log(totalHeight);
                    console.log(taskBoxHeight);
                    console.log(navHeight);
                    console.log(breadHeight);
                    console.log(paddingHeight);
                    document.querySelector('.' + main).style.paddingBottom = paddingHeight
                }.bind(this))
            }.bind(this)
            paddingH()
            window.onresize = function() {
                paddingH()
            }.bind(this)
        },


    }
}


// WEBPACK FOOTER //
// ./src/components/mixin/layout_mixin.js